const States = new (function () {
	var instance = this;
	var states = {};

	instance.get = function (success) {
		$.ajax({
			url: theme.statesURL,
			type: 'get',
			dataType: 'json',
			global: false,
			success: function (response) {
				states = response;

				if (typeof success == 'function') {
					success.call(success, response);
				}
			},
		});
	};

	instance.all = function () {
		return states;
	};
	(function construct(instance) {
		instance.get();
	})(this);
})();

export default States;
